/**
 * Created by Andriyanto.
 * E-Mail Address: 4lenour@gmail.com
 * Date: 25/06/2025
 */

/**
 * Created by Andriyanto.
 * E-Mail Address: 4lenour@gmail.com
 * Date: 25/06/2025
 */

export function recaptchaInit() {
    return new Promise((resolve, reject) => {
        const siteKey = document.querySelector('meta[name="rcapcay"]')?.getAttribute('content') || '';
        let script = document.getElementById('recaptcha-script');
        let element = document.getElementById('google-recaptcha');

        if (!siteKey) {
            // reject(new Error('reCAPTCHA site key not found'));
            resolve({ success: false, message: 'reCAPTCHA site key not found' });
            return;
        }

        if(!script) {
            // Load the reCAPTCHA script dynamically
            script = document.createElement('script');
            script.id = 'recaptcha-script';
            script.src = `https://www.google.com/recaptcha/api.js?render=${siteKey}`;
            script.async = true;
            script.defer = true;
            document.head.appendChild(script);
        }

        if(!element) {
            element = document.createElement('div');
            element.id = 'google-recaptcha';
            document.body.appendChild(element);
        }

        // Initialize reCAPTCHA when the script is loaded
        script.onload = () => {
            grecaptcha.ready(() => {
                if (element && element.innerHTML.trim() === '') {
                    grecaptcha.render(element, {
                        sitekey: siteKey,
                        size: 'invisible'
                    });
                }
                resolve({ success: true, message: 'reCAPTCHA initialized successfully' });
            });
        };
    });
}

export function recaptchaExecute() {
    return new Promise((resolve, reject) => {
        const siteKey = document.querySelector('meta[name="rcapcay"]')?.getAttribute('content') || '';
        if (typeof grecaptcha !== 'undefined' && siteKey) {
            const timeout = setTimeout(() => {
                reject(new Error('reCAPTCHA execution timed out'));
            }, 10000); // 10 seconds timeout

            grecaptcha.ready(() => {
                grecaptcha.execute(siteKey, { action: 'submit' })
                    .then(token => {
                        clearTimeout(timeout);
                        // Handle the verified token here
                        resolve(token); // Resolve the Promise with the token
                    })
                    .catch(error => {
                        clearTimeout(timeout);
                        // Handle errors, if any
                        reject(error); // Reject the Promise with the error
                    });
            });
        } else {
            const error = new Error('reCAPTCHA script not loaded or site key not found');
            reject(error); // Reject the Promise with the error
        }
    });
}

export function setBlurLoader(elements) {
    (Array.isArray(elements) ? elements : (elements?[elements]:[])).forEach(element => {
        const loader = document.createElement('div');
        const loaderBar = document.createElement('div');
        loaderBar.classList.add('dta-loader-bar');
        loader.classList.add('dta-loader-wrapper');
        loader.appendChild(loaderBar);
        removeBlurLoader(element);
        element.classList.add('dta-loading');
        element.appendChild(loader);
    });
}

export function removeBlurLoader(elements) {
    (Array.isArray(elements) ? elements : (elements?[elements]:[])).forEach(element => {
        const loader = element.querySelector('.dta-loader-wrapper');
        if(loader) {
            loader.remove();
        }
        element.classList.remove('dta-loading');
    });
}

export function formatNumber(number, locale = 'en-US', symbol = '') {
    if(typeof number !== 'number') {
        return '';
    }

    if(isNaN(number)) {
        return '';
    }

    return ( symbol ? (symbol + ' ') : '') + (new Intl.NumberFormat(locale, {
        style: 'decimal',
        minimumFractionDigits: (number % 1 === 0 ? 0 : 2),
        maximumFractionDigits: 2
    })).format(number);
}
